import React, { useEffect, useState } from "react";
import UserRoutes from "../routes/UserRoutes";
import { Route, Routes } from "react-router-dom";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import NotFound from "../pages/User/NotFound/NotFound";

const UserLayout = () => {
    const [isSidebarOpen, setSidebarOpen] = useState(false);
    const [isMobileView, setIsMobileView] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!isSidebarOpen);
    const closeSidebar = () => setSidebarOpen(false);

    useEffect(() => {
        const handleResize = () => {
            setIsMobileView(window.innerWidth < 1024);
        };
        handleResize();
        window.addEventListener('resize', handleResize);

        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <div id="root">
            <div className={`main-content`}>
                <Navbar toggleSidebar={toggleSidebar} />
                {isMobileView && <Sidebar isSidebarOpen={isSidebarOpen} closeSidebar={closeSidebar} />}
                <Routes>
                    {UserRoutes.map(({ path, element }, idx) => (
                        <Route key={idx} path={path} element={element} />
                    ))}
                    <Route path="*" element={<NotFound/>} />
                </Routes>
            </div>
            <Footer />
        </div>
    );
};

export default UserLayout;